import { queryOptions, useMutation, useQueryClient } from "@tanstack/react-query";
import type { CreateApiKeyInput } from "@repo/shared";

import { createApiKey, listApiKeys, revokeApiKey } from "@/lib/api/api-keys";

export const apiKeyKeys = {
  all: ["api-keys"] as const,
  list: () => [...apiKeyKeys.all, "list"] as const,
};

export const apiKeysQueryOptions = queryOptions({
  queryKey: apiKeyKeys.list(),
  queryFn: listApiKeys,
});

export function useCreateApiKey() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: CreateApiKeyInput) => createApiKey(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: apiKeyKeys.all });
    },
  });
}

export function useRevokeApiKey() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => revokeApiKey(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: apiKeyKeys.all });
    },
  });
}
